export default "__VITE_ASSET__9ba6faf0__"